import NoteContent from './NoteContent';

function NoteContainer({text, id, date, title, status, updateDate, onArchive, onDelete, setShowModal, setActiveNote}) {
  function onClickHandler() {
    setShowModal(true);
    setActiveNote(id);
  };

  return (
    <li className="notes-item" onClick={() => {onClickHandler()}}>
      <NoteContent
        date={date}
        title={title}
        text={text}
        status={status}
        updateDate={updateDate}
      />
      <button type="button" className="button-archive" onClick={(e) => onArchive(e, id)}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"/>
      </svg>
      </button>
      <button type="button" className="button-trash" onClick={(e) => onDelete(e, id)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
        </svg>
      </button>
    </li>
  );
}

export default NoteContainer;